/**
 * @generated SignedSource<<87568f3e24ab055faf2a69ddf1fcfa38>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4PlansForLanding$data = {
  readonly plansOrder?: {
    readonly " $fragmentSpreads": FragmentRefs<"PlansList_navigationCustomisation">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PlansList">;
  readonly " $fragmentType": "Nav4PlansForLanding";
};
export type Nav4PlansForLanding$key = {
  readonly " $data"?: Nav4PlansForLanding$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4PlansForLanding">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityAriPlans"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipOrderQuery"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4PlansForLanding",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PlansList"
    },
    {
      "condition": "skipOrderQuery",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "plansOrder",
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "entityAriPlans"
            },
            {
              "kind": "Variable",
              "name": "ownerAri",
              "variableName": "ownerAri"
            }
          ],
          "concreteType": "SettingsNavigationCustomisation",
          "kind": "LinkedField",
          "name": "settings_navigationCustomisation",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PlansList_navigationCustomisation"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "ad64684e81b02d75805fc1651695e692";

export default node;
